export default function ArrowRightIcon() {
  return (
    <svg
      width="10"
      height="10"
      className="rotate-180"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Arrow Right Icon</title>
      <path
        d="M16.7803 22.6438L8.58509 13.8551V16.0028L16.7803 7.35547L12.9088 7.35547L6.18304 14.2225L6.18304 15.6355L12.9088 22.6438H16.7803ZM23.8169 16.4267V13.5443H8.81117V16.4267H23.8169Z"
        fill="currentColor"
      />
    </svg>
  );
}
